import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import sso from './lib/sso';
import { syncAuthToLocalStorage, clearSsoAuthData } from './utils/authSync';
import { cleanDevelopersAddress } from './features/developers/address';

const PORTAL_URL = import.meta.env.VITE_PORTAL_URL || 'https://portal.roommatik.com';

const root = ReactDOM.createRoot(document.getElementById('root')!);

let initStarted = false;

async function bootstrap() {
  if (initStarted) return;
  initStarted = true;

  try {
    const authenticated = await sso.init({
      onLoad: 'login-required',
      pkceMethod: 'S256',
    });

    if (!authenticated) return;

    syncAuthToLocalStorage(sso);

    sso.onTokenExpired = () => {
      sso.updateToken(30)
        .then(refreshed => { if (refreshed) syncAuthToLocalStorage(sso); })
        .catch(() => { clearSsoAuthData(); window.location.href = PORTAL_URL; });
    };

    sso.onAuthRefreshSuccess = () => syncAuthToLocalStorage(sso);

    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  } catch {
    clearSsoAuthData();
    window.location.href = `${PORTAL_URL}?app=kyc`;
  }
}

// Before signing in: the address travels whole as the redirect URI (see developers/address.ts).
cleanDevelopersAddress();
bootstrap();
